module.exports = __webpack_public_path__ + "img/email.c1d34866.svg";